import * as React from 'react';
import Bs4GenericField from './Bs4GenericField';
import {Bs4ViewNumberSummaryDetails, Bs4ViewNumber} from '../../Bs4Components/Bs4ViewNumber';
import {isNullOrNaN} from '../../Bs4Components/Bs4Utils';

export default class Bs4Number extends Bs4GenericField {

  getValueBs4() {
    return this.getValue();
  }

  reloadGridCriteriaTimeoutID = null;

  ViewSummaryDetails = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue() || '');
    const decimals = parseInt(this.props.field.decimals) || 0;

    const handleChange = (value) => {      
      this.setValue(value);      
      try {
        clearTimeout(this.reloadGridCriteriaTimeoutID);
        this.reloadGridCriteriaTimeoutID = setTimeout(() => {
          this.reloadGridCriteria();
        }, 500);
      } catch (error) {}
    }      

    React.useEffect(() => {
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue() || '');
      })    
    }, []);

    return (
      <Bs4ViewNumberSummaryDetails
        id={this.props.inputId}
        value={value}
        onChange={handleChange}
        decimals={decimals}
        readOnly={formField.readOnly}
      />
    )
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue() || '');
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const decimals = parseInt(this.props.field.decimals) || 0;

    this.refFocus = React.useRef();
    
    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        let value = this.getValue();
        if (isNullOrNaN(value)) value = '';
        setValue(value);
        const minValue = parseFloat(this.props.field.minValue);
        const maxValue = parseFloat(this.props.field.maxValue);
        if (!isNullOrNaN(minValue) && value < minValue) {
          setError({error: true, helperText: value+'<'+minValue});
        } else if (!isNullOrNaN(maxValue) && value > maxValue) {
          setError({error: true, helperText: value+'>'+maxValue});
        } else setError(Bs4GenericField.NO_ERROR);  
      })    
    }, [error]);
        
    const handleChange = (newValue) => {
      if (isNaN(newValue)) newValue = 0;
      this.setValue(newValue);
    }

    return (
      <Bs4ViewNumber
        inputRef={this.refFocus}
        id={this.props.inputId}
        value={value}
        onValueChange={handleChange}
        decimals={decimals}
        label={<formField.Bs4Label/>}
        error={error.error}
        helperText={error.helperText}
        readOnly={formField.readOnly}
        name={formField.getLabelPlane()}
        suffix={formField.props.field.number_suffix || ''}
      />
    )
  }
}